import { ToastContainer } from "react-toastify";
import Routers from "./Routes";

const App = () => {
  return (
    <>
      <Routers />
      <ToastContainer />
    </>
  );
};

export default App;
